import { useIam } from '../../../services/IAm/hooks';
import Spinner from '../../Spinner';
import ButtonLink from '../../ButtonLink';
import styles from './styles.module.scss';
import { FunctionComponent } from 'react';
import { OriginString } from '@shared/types';

type UnauthorisedProps = {
    origin: OriginString;
    educatorId: string;
};
export const Unauthorised: FunctionComponent<UnauthorisedProps> = ({ origin, educatorId }) => {
    const { iam, iamReady } = useIam();

    if (iamReady === false) {
        return (
            <div className={styles.container}>
                <Spinner />
            </div>
        );
    }

    if (iam.authenticated) {
        return (
            <div className={styles.container}>
                <h1>Restricted Course</h1>
                <p>You do not have access to this course.</p>
            </div>
        );
    }

    const loginLinkParams = new URLSearchParams({ redirect: window.location.href });
    if (origin !== 'marketplace') {
        loginLinkParams.set('educator', educatorId);
    }
    const loginLink = `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/login?${loginLinkParams.toString()}`;

    return (
        <div className={styles.container}>
            <h1>Restricted Course</h1>
            <p>You may need to log in to access this course</p>
            <ButtonLink href={loginLink}>Login</ButtonLink>
        </div>
    );
};

export default Unauthorised;
